import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { useClinicClock } from "@/hooks/use-clinic-clock";
import { clinicDayMarker } from "@/lib/clinic-clock";
import { mergeDateKeepingTime } from "@/lib/measurement-utils";

/**
 * A date picker over a moment (a reading's or a dose's time): it shows the
 * clinic day the moment falls on, and a picked day keeps the clinic time of
 * day the moment already held — now, when there is none yet. Both read the
 * same clock.
 */
export function useClinicDayField(moment, setMoment) {
  const $ = _c(10);
  const clock = useClinicClock();
  let t0;
  if ($[0] !== clock || $[1] !== moment) {
    t0 = moment ? clinicDayMarker(moment, clock) : undefined;
    $[0] = clock;
    $[1] = moment;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const value = t0;
  let t1;
  if ($[3] !== clock || $[4] !== moment || $[5] !== setMoment) {
    t1 = day => setMoment(day ? mergeDateKeepingTime(day, moment ?? new Date(), clock.timeZone) : undefined);
    $[3] = clock;
    $[4] = moment;
    $[5] = setMoment;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const onChange = t1;
  let t2;
  if ($[7] !== onChange || $[8] !== value) {
    t2 = {
      value,
      onChange
    };
    $[7] = onChange;
    $[8] = value;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}